import { render } from "./P019.vue?vue&type=template&id=48c72df3&scoped=true"
import script from "./P019.vue?vue&type=script&lang=js"
export * from "./P019.vue?vue&type=script&lang=js"

import "./P019.vue?vue&type=style&index=0&id=48c72df3&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c72df3"]])

export default __exports__